import {awsFetchRest} from 'utils/asyncUtils'
import config from 'config'

class CaptchaService {
  static shouldShowCaptcha = async () => {
    const response = await awsFetchRest(`${config.backendUrl}/v2/email/quota`, 'GET')
    return response.captchaRequired
  }

  static checkCaptchaV3 = async ({email, action}) => {
    if (!process.env.REACT_APP_RECAPTCHA_V3_KEY) return Promise.resolve()

    const token = await new Promise(resolve => {
      try {
        grecaptcha.ready(async () => {
          const token = await grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_V3_KEY, {action})
          resolve(token)
        })
      } catch {
        resolve()
      }
    })

    if (token) {
      await awsFetchRest(`${config.backendUrl}/v2/recaptcha-verify`, 'POST', {token, email, action})
    }
  }
}

export default CaptchaService
